import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AUTH_KEYS, clearAuth, getSession } from "./auth";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const [session, setSession] = useState(getSession);
  useEffect(() => {
    let timer;
    let previous = getSession();
    const expired = () => {
      window.clearTimeout(timer);
      previous = null;
      setSession(null);
      navigate("/", { replace: true });
    };
    const sync = () => {
      window.clearTimeout(timer);
      const next = getSession();
      if (!next && (previous || AUTH_KEYS.some((key) => localStorage.getItem(key) !== null))) {
        clearAuth();
        return;
      }
      previous = next;
      setSession(next);
      if (next) timer = window.setTimeout(sync, Math.min(Math.max(0, next.expiresAt - Date.now()), 2147483647));
    };
    const storage = (event) => { if (event.key === null || AUTH_KEYS.includes(event.key)) sync(); };
    window.addEventListener("auth-expired", expired);
    window.addEventListener("auth-changed", sync);
    window.addEventListener("storage", storage);
    window.addEventListener("focus", sync);
    document.addEventListener("visibilitychange", sync);
    sync();
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("auth-expired", expired);
      window.removeEventListener("auth-changed", sync);
      window.removeEventListener("storage", storage);
      window.removeEventListener("focus", sync);
      document.removeEventListener("visibilitychange", sync);
    };
  }, [navigate]);
  return <AuthContext.Provider value={{ session, isAuthenticated: Boolean(session) }}>{children}</AuthContext.Provider>;
}
